/* Product */
import '../partials/product/product-slider/product-slider';
import '../partials/product/product-info/product-info';
import '../partials/product/product-description/product-description';
import '../partials/product/wish-list/wish-list-add/wish-list-add';
import '../partials/product/relative-product-slider/relative-product-slider';

/* Review */
import '../partials/content/review/review-add/review-add';
import '../partials/content/review/review-list/review-list';

/* $(document).ready(() => {
  if ($('._shopaholic-product-wrapper').length > 0) {
    // this will disable dragging of all images
    $('img').mousedown((e) => {
      e.preventDefault();
    });

    // this will disable right-click on all images
    $('body').on('contextmenu', e => false);
  }
}); */
